export const ADDRESS_HEADER = 'Address';

export const STREET_ADDRESS = 'Street Address';
export const APT_UNIT = 'Apt / Unit (optional)';
export const CITY = 'City';
export const STATE = 'State';
export const ZIP_CODE = 'Zip Code';
export const COUNTRY = 'Country';

export const USA = 'USA';

export const streetRequired = 'Street address is required';
export const cityRequired = 'City is required';
export const zipcodeRequired = 'Zipcode is required';
